module.exports = __webpack_public_path__ + "static/media/10.41e36e9b.jpg";